
import React, { useState, useEffect } from 'react';
import Button from './../ui/Button';
import './../../styles/TransferModal.css'; 

const TransferRequestModal = ({ isOpen, user, onClose, onSubmit }) => {
  const [details, setDetails] = useState('');

  useEffect(() => {
    if (user) {
      setDetails(
        `I would like to transfer user ${user.visorId} from "${user.groupName || 'current group'}" to the Not Monitored group.`
      );
    } else {
      setDetails('');
    }
  }, [user]);

  if (!isOpen || !user) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!details.trim()) return;
    onSubmit(details.trim());
  };

  return (
    <div className="transfer-modal-overlay">
      <div className="transfer-modal-content transfer-modal">
        <div className="transfer-modal-header">
          <h2 className="transfer-modal-title">Request user transfer</h2>
          <button
            type="button"
            className="transfer-modal-close-btn"
            onClick={onClose}
            aria-label="Close transfer request modal"
          >
            ×
          </button>
        </div>

        <div className="transfer-modal-body">
          <div className="transfer-summary">
            <p className="transfer-summary-label">User</p>
            <p className="transfer-summary-value">
              <strong>{user.visorId}</strong>
            </p>

            <p className="transfer-summary-label">Current group</p>
            <p className="transfer-summary-value">
              {user.groupName || '—'}
            </p>
          </div>

          <label className="transfer-modal-field-label" htmlFor="transfer-details">
            Transfer details
          </label>
          <p className="transfer-modal-field-helper">
            Please include a clear reason and the destination group, for example:
            <br />
            <em>“I want to transfer this user to the Not Monitoring group.”</em>
          </p>

          <textarea
            id="transfer-details"
            className="transfer-modal-textarea"
            rows={5}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            placeholder='E.g. "I want to transfer this user to the Not Monitoring group."'
          />
        </div>

        <div className="transfer-modal-footer">
          <Button
            buttonStyle="btn-alternate"
            className="transfer-modal-btn transfer-modal-btn-secondary"
            type="button"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            buttonStyle="btn-main"
            className="transfer-modal-btn transfer-modal-btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            Submit transfer request
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TransferRequestModal;
